import { MapCustomControlProps } from "@app/shared/mapping/MapCustomControlProps"
import { useMapboxControl } from "@app/shared/mapping/useMapBoxControl";
import { createPortal } from 'react-dom';

export const RecenterControl: React.FC<MapCustomControlProps> = ({ ignoreInMapExport, imagePath, mapRef, onClick, position}) => {
 
  const container = useMapboxControl({mapRef, position});
  if (!container) return null;

  return createPortal (
    <div {...(ignoreInMapExport ? { 'data-html2canvas-ignore': '' } : {})} className="recenter-control" onClick={onClick}>
      <img src={imagePath} alt="Recenter" className="recenter-icon" />
    </div>, 
    container
  )
};